module.exports = __webpack_public_path__ + "static/media/Trapezium1.2dc07479.jpg";